module.exports = __webpack_public_path__ + "img/IGNIS-GL-ROJO.2fd07551.png";